/* ============
 * Getters for the user module
 * ============
 *
 * The getters that are available on the
 * user module.
 */

export default {
  popupNpsFinal: state => { return state.popupNpsFinal },
  taggeoNps: state => { return state.taggeoNps }
}



// WEBPACK FOOTER //
// ./src/store/modules/nps/getters.js